import { useEffect, useRef } from 'react';

const REVEAL_SELECTOR = '[data-reveal]';

/**
 * Добавляет visibleClassName элементам с атрибутом data-reveal внутри контейнера,
 * когда они попадают в зону видимости. Каждый элемент проявляется один раз.
 */
export const useRevealOnScroll = <T extends HTMLElement>(visibleClassName: string) => {
  const containerRef = useRef<T>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const elements = Array.from(container.querySelectorAll<HTMLElement>(REVEAL_SELECTOR));

    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach((element) => element.classList.add(visibleClassName));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(visibleClassName);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [visibleClassName]);

  return containerRef;
};
